import {api} from "../../api.ts";


interface BillingReportRequest {
    dateFrom: string;
    dateTo: string;
    type: string;
    timezone: string;
}

export const billingApi = api.injectEndpoints({
    endpoints: (builder) => ({
        generateBillingReport: builder.mutation<any, BillingReportRequest>({
            query: (data) => ({
                url: '/api/v1/reports',
                method: 'POST',
                body: data,
                responseHandler: (response: any) => response.blob(),

            }),
            transformResponse: (data: Blob) => {
                const pdfBlob = new Blob([data]);
                return URL.createObjectURL(pdfBlob);
            },
        }),
    }),
});

export const {
    useGenerateBillingReportMutation,
} = billingApi;
